import React from 'react';
import { SafeHtml } from '@shared/ui';
export const reactElementAdapter = (content) => {
    if (!content) {
        return null;
    }
    if (React.isValidElement(content)) {
        return content;
    }
    if (typeof content === 'string') {
        return React.createElement(SafeHtml, { tag: "div", html: content });
    }
    return null;
};
